
import { Bell, BellOff } from "lucide-react";

interface HeaderProps {
  notificationsEnabled: boolean;
}

const Header = ({ notificationsEnabled = false }: HeaderProps) => {
  return (
    <div className="flex items-center gap-2">
      {notificationsEnabled ? (
        <Bell className="h-6 w-6 text-primary" />
      ) : (
        <BellOff className="h-6 w-6 text-muted-foreground" />
      )}
      <h1 className="text-3xl font-bold">Notification Tester</h1>
    </div>
  );
};

export default Header;
